// Ravana Migration Package Information
// Based on Flight Plan™ Alliance Partner

export const ravanaPackages = {
  diy: {
    id: 'diy',
    slug: 'diy',
    name: 'DIY Package',
    priceLKR: 400000,
    priceDisplay: 'LKR 400,000',
    refundable: false,
    refundNote: 'Non-refundable',
    description: 'Self-managed pathway with expert checks and guidance when you need it.',
    features: [
      'Document verification for all 5 Flight Plan™ Alliance countries',
      'SOP/CV/LoR feedback & formatting support',
      'Comprehensive eligibility assessment',
      'Client portal access with status tracking',
      'Email support during business hours'
    ],
    targetAudience: 'Self-motivated students who want guidance while managing their own process',
    paymentPlan: {
      upfront: 400000,
      afterOffer: 0,
      final: 0
    },
    highlights: [
      'All 5 countries covered',
      'Expert verification',
      'Cost-effective option'
    ]
  },
  plus: {
    id: 'plus',
    slug: 'essential',
    name: 'Essential Package',
    priceLKR: 850000,
    priceDisplay: 'LKR 850,000',
    refundable: true,
    refundNote: 'Partially Refundable',
    description: 'Smart choice for qualified students who want end-to-end handling for one country.',
    features: [
      'Everything in DIY, plus:',
      '3 German public university applications managed for you',
      'Visa documentation review & appointment scheduling',
      'Blocked account and public health insurance guidance',
      'Document review with prioritized feedback',
      'LKR 25,000 referral commission per successful referral'
    ],
    targetAudience: 'Budget-conscious students ready with documents who want guided delivery',
    paymentPlan: {
      upfront: 425000, // 50%
      afterOffer: 425000, // 50%
      final: 0
    },
    highlights: [
      'Full visa package for one destination',
      'Hands-on documentation support',
      'Referral rewards program'
    ]
  },
  pro: {
    id: 'pro',
    slug: 'premium',
    name: 'Premium Package',
    priceLKR: 1190000,
    priceDisplay: 'LKR 1,190,000',
    refundable: true,
    refundNote: 'Partially Refundable',
    description: 'Complete peace of mind with success guarantee, multiple applications, and premium benefits.',
    features: [
      'Everything in Essential, plus:',
      'Apply to ALL 5 countries with one profile',
      '5+ university applications (3 public + 2 private backup)',
      'Application Success Guarantee (free re-application next semester)',
      'Dedicated consultant with priority support line',
      'Free IELTS prep course + first month travel insurance',
      'Student & alumni network with 25% family visa discount',
      'LKR 50,000 referral commission per successful referral',
      '100GB cloud storage + dedicated email + 1 year Google Gemini Pro access'
    ],
    targetAudience: 'Families and professionals seeking the safest all-inclusive pathway with backups',
    paymentPlan: {
      upfront: 595000, // 50%
      afterOffer: 595000, // 50%
      final: 0
    },
    highlights: [
      'Application success guarantee included',
      'Covers all 5 Flight Plan™ Alliance countries',
      'Premium support, travel & tech benefits'
    ]
  }
};

// Entry Requirements (common to all packages)
export const entryRequirements = {
  minimumOne: [
    'A/L 3 Passes (any stream)',
    'Bachelor\'s Degree or Equivalent Qualification',
    'IELTS 6.0 (Applicants who haven\'t taken the test can still apply)'
  ],
  financial: [
    'Show Money / Blocked Account: Minimum of LKR 5 Million for proof of funds'
  ],
  additional: [
    'Contract-first & transparent pricing',
    'Bank transfer only – no hidden fees',
    'Fintiba Official Partner',
    'Best-in-class Client Portal',
    '100% monitored timelines and updates'
  ]
};

// Package comparison helper
export const getPackageComparison = () => {
  return [
    {
      feature: 'Countries Covered',
      diy: 'All 5 (self-managed)',
      plus: 'One country (full-service delivery)',
      pro: 'All 5 countries (full-service delivery)'
    },
    {
      feature: 'University Applications',
      diy: 'Self-managed',
      plus: '3 public applications managed for you',
      pro: '5+ applications (3 public + 2 private)'
    },
    {
      feature: 'Success Guarantee',
      diy: 'No',
      plus: 'No',
      pro: 'Yes (free re-application next semester)'
    },
    {
      feature: 'Dedicated Consultant',
      diy: 'No',
      plus: 'Priority document review',
      pro: 'Dedicated consultant + priority line'
    },
    {
      feature: 'Free IELTS Course',
      diy: 'No',
      plus: 'No',
      pro: 'Included (worth LKR 80,000)'
    },
    {
      feature: 'Referral Commission',
      diy: 'No',
      plus: 'LKR 25,000',
      pro: 'LKR 50,000'
    },
    {
      feature: 'Family Discount',
      diy: 'No',
      plus: 'No',
      pro: '25% off family visas'
    },
    {
      feature: 'Tech Package',
      diy: 'Client portal basics',
      plus: 'Client portal with priority updates',
      pro: 'Cloud storage + Gemini Pro + dedicated email'
    }
  ];
};

// Helper functions
export const getPackageById = (packageId) => {
  return ravanaPackages[packageId] || null;
};

export const getAllPackages = () => {
  return Object.values(ravanaPackages);
};

export const getRecommendedPackage = (profile) => {
  // Simple recommendation logic based on user profile
  if (profile.experience === 'self-managed' && profile.budget === 'low') {
    return 'diy';
  } else if (profile.experience === 'guided' && profile.countries === 'one') {
    return 'plus';
  } else {
    return 'pro'; // Default recommendation
  }
};
